
const base_url = "/api/trips";

export const submitTrip = (trip) => {

    return fetch(`${base_url}`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(trip)
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}


export const searchTrips = (searchId) => {

    return fetch(`${base_url}/search/${searchId}`, {
        headers: {
            "Content-Type": "application/json"
        }
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}

export const retrieveTripByCode = (tripCode) => {

    return fetch(`${base_url}/by-tripcode/${tripCode}`, {
        headers: {
            "Content-Type": "application/json"
        }
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}


export const loadDashbordData = (userId) => {

    return fetch(`${base_url}/${userId}`, {
        headers: {
            "Content-Type": "application/json"
        }
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}

export const updateStatus = (tripCode, statusCode) => {

    return fetch(`${base_url}/update-status/${tripCode}/${statusCode}`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST"
    }).then(results => {
        if(results.ok) {
            return results.json();
        }

        return Promise.reject(results.json())
    });

}

